// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-chip {
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    gap: 0.375rem;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: rgb(233 240 247 / var(--tw-bg-opacity, 1));
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.625rem;
    padding-right: 0.5rem;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(29 86 153 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.filter-chip:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(212 225 240 / var(--tw-bg-opacity, 1))
}

.filter-chip-clear {
    display: flex;
    cursor: pointer;
    align-items: center;
    border-radius: 9999px;
    padding: 0.125rem;
    --tw-text-opacity: 1;
    color: rgb(37 98 169 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.filter-chip-clear:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(179 202 228 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(26 69 118 / var(--tw-text-opacity, 1))
}`, "",{"version":3,"sources":["webpack://./src/components/Table/FilterChip.scss"],"names":[],"mappings":"AACE;IAAA,oBAAA;IAAA,eAAA;IAAA,mBAAA;IAAA,aAAA;IAAA,qBAAA;IAAA,kBAAA;IAAA,4DAAA;IAAA,oBAAA;IAAA,uBAAA;IAAA,sBAAA;IAAA,qBAAA;IAAA,kBAAA;IAAA,iBAAA;IAAA,gBAAA;IAAA,oBAAA;IAAA,iDAAA;IAAA,+FAAA;IAAA,wDAAA;IAAA;AAAA;AAGE;IAAA,kBAAA;IAAA;AAAA;;AAKF;IAAA,aAAA;IAAA,eAAA;IAAA,mBAAA;IAAA,qBAAA;IAAA,iBAAA;IAAA,oBAAA;IAAA,iDAAA;IAAA,+FAAA;IAAA,wDAAA;IAAA;AAAA;AAGE;IAAA,kBAAA;IAAA,4DAAA;IAAA,oBAAA;IAAA;AAAA","sourcesContent":[".filter-chip {\n  @apply inline-flex cursor-pointer items-center gap-1.5 rounded-full bg-primary-50 py-1 pl-2.5 pr-2 text-xs font-medium text-primary-700 transition-colors;\n\n  &:hover {\n    @apply bg-primary-100;\n  }\n}\n\n.filter-chip-clear {\n  @apply flex cursor-pointer items-center rounded-full p-0.5 text-primary-600 transition-colors;\n\n  &:hover {\n    @apply bg-primary-200 text-primary-800;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
